import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import FormItem from '../../components/form/FormItem'
import { MdTitle } from 'react-icons/md'
import { BiX } from 'react-icons/bi'
import { Button, Form } from 'reactstrap'
import { fetchSeoGet } from '../../redux/slices/seoGetSlice'
import { fetchSeoCreate } from '../../redux/slices/seoCreateSlice'
import { fetchSeoUpdate } from '../../redux/slices/seoUpdateSlice'

const CrudSeo = ({ showMenu, setShowMenu, setChanged, setSelectedItem, selectedItem, t }) => {
    const [formData, setFormData] = useState({ files: [], canonical: "", author: "" })
    const dispatch = useDispatch()

    const getData = async () => {
        if (selectedItem !== 0) {
            var data = await dispatch(fetchSeoGet({ id: selectedItem }))
            if (data.payload) {
                setFormData({
                    files: data.payload?.files,
                    titletr: data.payload?.title["tr"],
                    titleen: data.payload?.title["en"],
                    descriptiontr: data.payload?.description["tr"],
                    descriptionen: data.payload?.description["en"],
                    keywordstr: data.payload?.keywords["tr"],
                    keywordsen: data.payload?.keywords["en"],
                    canonical: data.payload?.canonical,
                    author: data.payload?.author,
                })
            }
        }
    }

    const closeModal = () => {
        setFormData({ files: [], titletr: "", titleen: "", descriptiontr: "", descriptionen: "", keywordstr: "", keywordsen: "", canonical: "", author: "" })
        setShowMenu(!showMenu)
        setSelectedItem(0)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const title = { "tr": formData.titletr, "en": formData.titleen }
        const description = { "tr": formData.descriptiontr, "en": formData.descriptionen }
        const keywords = { "tr": formData.keywordstr, "en": formData.keywordsen }

        await dispatch(
            selectedItem === 0 ?
                fetchSeoCreate({ file: formData.files, title: title, description: description, keywords: keywords, canonical: formData.canonical, author: formData.author }) :
                fetchSeoUpdate({ id: selectedItem, file: formData.files, title: title, description: description, keywords: keywords, canonical: formData.canonical, author: formData.author })
        )
        closeModal()
        setChanged(true)
        getData()
        setShowMenu(false)
    }

    useEffect(() => { getData() }, [dispatch, selectedItem])

    return (
        <div className={showMenu ? 'right-popup' : 'd-none'}>
            <div className='right-popup-close' onClick={closeModal}><BiX size={24} /></div>
            <div className='right-popup-menu'>
                <div className='mb-3 text-center'><h5>{t(selectedItem === 0 ? "add_seo" : "edit_seo")}</h5></div>
                <Form onSubmit={handleSubmit}>
                    <FormItem
                        id={`titletr`}
                        name={`titletr`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("title")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='titletr'
                    />
                    <FormItem
                        id={`titleen`}
                        name={`titleen`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("title")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='titleen'
                    />
                    <FormItem
                        id={`descriptiontr`}
                        name={`descriptiontr`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("description")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='descriptiontr'
                    />
                    <FormItem
                        id={`descriptionen`}
                        name={`descriptionen`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("description")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='descriptionen'
                    />
                    <FormItem
                        id={`keywordstr`}
                        name={`keywordstr`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("keywords")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='keywordstr'
                    />
                    <FormItem
                        id={`keywordsen`}
                        name={`keywordsen`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("keywords")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='keywordsen'
                    />
                    <FormItem
                        id={`canonical`}
                        name={`canonical`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("canonical")}`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='canonical'
                    />
                    <FormItem
                        id={`author`}
                        name={`author`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("author")}`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='author'
                    />

                    <div className='d-flex justify-content-end mt-4 w-100'>
                        <Button type='submit' color={selectedItem === 0 ? 'primary' : 'warning'} className="text-white">
                            {t(selectedItem === 0 ? "add" : "edit")}
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default CrudSeo